import { api } from '../../api/client';

export type ScanKind =
  | 'component'
  | 'location'
  | 'serial'
  | 'purchase'
  | 'project'
  | 'spec_version'
  | 'stocktake'
  | 'package';

export interface ScanMatch {
  kind: ScanKind;
  id: string;
  code: string;
  title: string;
  subtitle: string | null;
  /** Set when the label in hand belongs to a record that was merged away. */
  redirected_from: string | null;
  /** True when a manufacturer's barcode matched rather than one of our codes. */
  via_barcode: boolean;
  /** The record to open when the match has no screen of its own — a tracked
   *  unit's label is scanned to get at the part it is an instance of. */
  opens_component_id: string | null;
}

export interface ScanResult {
  resolved: boolean;
  match: ScanMatch | null;
  value: string;
  symbology: string | null;
  /** Codes one keystroke from what was typed. This is what stands in for a
   *  check character: instead of "invalid code", the record you probably meant. */
  suggestions: ScanMatch[];
}

export interface Barcode {
  id: string;
  component_id: string;
  value: string;
  symbology: string;
  source: string | null;
}

export const resolveScan = (value: string, symbology?: string) => {
  const query = new URLSearchParams({ q: value });
  if (symbology) query.set('symbology', symbology);
  return api.get<ScanResult>(`/resolve?${query.toString()}`);
};

export const listBarcodes = (componentId: string) =>
  api.get<Barcode[]>(`/components/${componentId}/barcodes`);

export const bindBarcode = (
  componentId: string,
  input: { value: string; symbology?: string; source?: string },
) => api.post<Barcode>(`/components/${componentId}/barcodes`, input);

export const unbindBarcode = (componentId: string, barcodeId: string) =>
  api.delete<void>(`/components/${componentId}/barcodes/${barcodeId}`);
